import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MENU } from 'src/app/components/container/menu';

@Component({
  selector: 'app-standard-training-pack',
  templateUrl: './standard-training-pack.component.html',
  styleUrls: ['./standard-training-pack.component.scss']
})
export class StandardTrainingPackComponent {
  iframeUrl: SafeResourceUrl;
  menu: string[] = MENU.map(map => {
    return map.ref;
  }).concat(['standard-training-pack']);

  constructor(private sanitizer: DomSanitizer) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://mlvt-dsc.info/Standard-Training-Pack');
  }
}
